import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';

import { BulkActionsComponent } from './bulk-actions.component';

@NgModule({
	declarations: [BulkActionsComponent],
	exports: [BulkActionsComponent],
	imports: [CommonModule, SharedModule],
})
export class BulkActionsModule {}
